import { render, staticRenderFns } from "./StIconCarousel.vue?vue&type=template&id=24a8f6e1"
import script from "./StIconCarousel.vue?vue&type=script&lang=ts"
export * from "./StIconCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports